export const TOOLTIP_ARROW = `<svg
	class="timeline-tooltip-arrow"
	viewBox="0 0 7 10"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
<path
		d="M0.75 8.75L5.75 4.75L0.75 0.75"
		stroke="#8E8E93"
		stroke-width="1.5"
		stroke-linecap="round"
	/>
</svg>`;

export const STEP_INTERVAL = 320;
